import { StorageService } from './../../auth/_services/storage.service';
import { ActivatedRoute } from '@angular/router';
import { Pet } from './../../auth/_models/pet';
import { PetsService } from './../../auth/_services/pets.service';
import { Component, OnInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'app-pet-detail',
  templateUrl: './pet-detail.component.html',
  styleUrls: ['./pet-detail.component.css'],
  providers: [PetsService, StorageService],
})
export class PetDetailComponent implements OnInit {

  pet: Pet;

  constructor(
    private _service: PetsService,
    private _route: ActivatedRoute,
  ) {
    this.pet = new Pet();
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      const uuid = params['id'];
      this._service
        .getPet(uuid)
        .valueChanges()
        .subscribe(p => {

          if (p.birthday) {
            if (typeof p.birthday.toDate === 'function') {
              p.birthday = p.birthday.toDate();
            }
          }

          console.log('p.profilePhoto', p.photoUrl);
          // console.log('url(' + p.photoUrl + ') no-repeat center center;'));

          if (typeof p.photoUrl !== 'undefined' && p.photoUrl !== '') {

            $('.profile-pet-photo').css('background-image', 'url(' + p.photoUrl + ')');
            $('.profile-pet-photo .no-photo').hide();
            // console.log('url(' + p.photoUrl + ') no-repeat center center;'));
          } else {
            $('.profile-pet-photo .no-photo').show();
          }

          this.pet = p;
        });
    });
  }

}
